import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { baseReducerActions } from '@util/data/base-reducer-actions';

import { initialCommonState } from './common.initial-state';

export const commonSlice = createSlice({
  name: 'common',
  initialState: initialCommonState,
  reducers: {
    ...baseReducerActions(initialCommonState),
    setInvite: (state, { payload }: PayloadAction<string>) => {
      state.data.invite = payload;
    },
  },
});

export const commonActions = commonSlice.actions;
